// Search Code - Desktop --------------------------------------------------------------------------------------------------------
const searchButton = document.querySelector('.search-id');
const closeButton = document.querySelector('.close-search');
const searchContainer = document.querySelector('.search-container');
const results = document.getElementById('predictive-search-results');
const backdrop = document.querySelector('.backdrop');
const body = document.body;

let scrollPosition = 0;

function lockScroll() {
  scrollPosition = window.pageYOffset;

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  body.style.paddingRight = `${scrollbarWidth}px`;

  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${scrollPosition}px`;
  body.style.width = '100%';
}

function unlockScroll() {
  body.style.overflow = '';
  body.style.position = '';
  body.style.paddingRight = '';
  body.style.top = '';
  body.style.width = '';
  window.scrollTo(0, scrollPosition);
}

searchButton?.addEventListener('click', () => {
  lockScroll();

  searchContainer.style.display = 'flex';
  results.style.display = 'flex';
  backdrop.style.display = 'block';

  setTimeout(() => {
    searchContainer.classList.add('show');
    results.classList.add('show');
    backdrop.classList.add('show');
  }, 10);
});

closeButton?.addEventListener('click', closeSearch);

document.addEventListener('click', (event) => {
  if (
    searchContainer.classList.contains('show') &&
    !searchContainer.contains(event.target) &&
    !searchButton.contains(event.target)
  ) {
    closeSearch();
  }
});

function closeSearch() {
  unlockScroll();

  searchContainer.classList.remove('show');
  results.classList.remove('show');
  backdrop.classList.remove('show');

  setTimeout(() => {
    searchContainer.style.display = 'none';
    results.style.display = 'none';
    backdrop.style.display = 'none';
  }, 300);
}

// Predictive Search -------------------------------------------------------------------------------------------------------------
document.getElementById('predictive-search-input').addEventListener('input', function (event) {
  const query = event.target.value;
  const resultsContainer = document.querySelector('.global-search-results');

  if (query.length < 2) {
    resultsContainer.classList.remove('show');
    document.getElementById('predictive-search-results').innerHTML = '';
    return;
  }

  resultsContainer.classList.add('show');

  fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
    .then((response) => response.json())
    .then((data) => {
      const results = data.resources.results.products;

      if (results.length === 0) {
        const noResultsText = document.getElementById('search-locale')?.dataset.noResults || 'No products found';
        document.getElementById('predictive-search-results').innerHTML = `
            <div class="p-5 text-center text-gray-500">${noResultsText}</div>
        `;
        return;
      }

      const resultsHTML = results
        .map((product) => {
          const truncatedTitle = product.title.length > 90 ? product.title.slice(0, 90) + '...' : product.title;
          const isAvailable = product.available;
          const priceLabel = isAvailable ? product.price : 'Out of stock';

          return `<div>
              <a class="w-full" href="${product.url}">
                  <div class="search-product-container md:w-[97%] w-full flex gap-3 items-center border-b-2 border-black pb-3">
                      <div class="md:w-2/12 w-3/12">
                          <img class="h-[80px] pt-3 w-auto mx-auto" src="${product.featured_image.url}" alt="${product.title}" />
                      </div>
                      <div class="flex flex-col gap-2 md:w-10/12 w-9/12">
                        <span class="text-sm pt-3">${truncatedTitle}</span>
                        <span class="text-sm text-mustarda">${priceLabel}</span>
                      </div>
                  </div>
              </a>
          </div>`;
        })
        .join('');

      document.getElementById('predictive-search-results').innerHTML = resultsHTML;
    });
});
// ------------------------------------------------------------------------------------------------------------------------------
